import { ContentChild, Directive, Input, TemplateRef } from '@angular/core';
import { TableRowTemplateDirective } from './table-row-template.directive';

@Directive({ selector: '[tTemplate]' })
export class TableTemplate {
  @Input() type!: string;
  @Input('tTemplate') name!: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name;
  }
}
